import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../api.service';
import { HttpParams } from "@angular/common/http";
import { CustomQuestion } from "../../../typings";

@Injectable({
  providedIn: 'root'
})
export class InitialInterviewApiService {
  constructor(private apiService: ApiService) {
  }

  provideCustomQuestions(jobPostingId: number, personId: number): Observable<CustomQuestion[]> {
    const params = new HttpParams()
      .set('personId', String(personId))
      .set('jobPostingId', String(jobPostingId));
    return this.apiService.httpWrapper<CustomQuestion[]>({
      method: 'POST',
      url: `api/custom-questions/provide`,
      params
    });
  }

  saveCustomQuestionAnswer(customQuestionId: number, answer: String): Observable<any> {
    const params = new HttpParams()
      .set('customQuestionId', String(customQuestionId))
      .set('answer', String(answer));
    return this.apiService.httpWrapper<void[]>({
      method: 'POST',
      url: `/api/custom-questions/save`,
      params
    });
  }

  submitCustomQuestionAnswers(customQuestionIds: number[], orderId: number, personId: number): Observable<any> {
    const params = new HttpParams()
      .set('customQuestionIds', String(customQuestionIds))
      .set('orderId', orderId)
      .set('personId', personId);
    return this.apiService.httpWrapper<void[]>({
      method: 'POST',
      url: `/api/custom-questions/submit`,
      params
    });
  }

  sendDoThisLaterEmail(postingId: number, personId: number, talentName: string, talentLastName: string, talentEmail: string, jobTitle: string, gatherUUID: string): Observable<any> {
    const params = new HttpParams()
      .set('postingId', postingId.toString())
      .set('talentName', talentName)
      .set('talentLastName', talentLastName)
      .set('talentEmail', talentEmail)
      .set('personId', personId)
      .set('jobTitle', jobTitle)
      .set('gatherUUID', gatherUUID);
    return this.apiService.httpWrapper<any>({
      method: 'POST',
      url:`/api/quick-apply/send-do-this-later-email`,
      params
    });
  }

  createTalentProfileActivity(activityTypeId: number, personId: number, orderId: number, jobPostingId: number) {
    this.apiService.httpWrapper<any>({
      method: 'POST',
      url: `/api/profile/activity`,
      body: {
        activityTypeId: activityTypeId,
        personId: personId,
        orderId: orderId,
        jobPostingId: jobPostingId
      }
    }).subscribe(() => {
      console.log('Activity saved');
    }, (error) => {
      console.error('Error saving activity', error);
    });
  }

  createTalentSubmittedQuestionsActivity(personId: number, orderId: number, jobPostingId: number) {
    const params = new HttpParams()
      .set('jobPostingId', jobPostingId.toString())
      .set('personId', personId.toString())
      .set('orderId', orderId.toString());
    return this.apiService.httpWrapper<any>({
      method: 'POST',
      url: `/api/initial-interview-questions/activity`,
      params: params
    });
  }

  addStandardInterviewQuestion(personId: number, orderId: number, question: string): Observable<CustomQuestion[]> {
    const params = new HttpParams()
      .set('personId', String(personId))
      .set('orderId', String(orderId))
      .set('question', String(question))
    return this.apiService.httpWrapper<CustomQuestion[]>({
      method: 'POST',
      url: `/api/custom-questions/add-standard-interview-question`,
      params
    })
  }

  saveTalentPayTransparencyRate(personId: number, orderId: number, jobPostingId: number, payRate: number): Observable<any> {
    const params = new HttpParams()
      .set('payRate', payRate.toString())
      .set('personId', personId.toString())
      .set('jobPostingId', jobPostingId.toString())
      .set('orderId', orderId.toString());
    return this.apiService.httpWrapper<any>({
      method: 'POST',
      url: `/api/initial-interview-questions/pay-transparency/submit`,
      params: params
    });
  }

  readTalentPayTransparencyRate(personId: number, orderId: number): Observable<any> {
    const params = new HttpParams()
      .set('personId', personId.toString())
      .set('orderId', orderId.toString());
    return this.apiService.httpWrapper<any>({
      method: 'GET',
      url: `/api/initial-interview-questions/pay-transparency/read`,
      params: params
    });
  }

  readTalentPayTransparencyData(personId: number, orderId: number): Observable<any> {
    const params = new HttpParams()
      .set('personId', personId.toString())
      .set('orderId', orderId.toString());
    return this.apiService.httpWrapper<any>({
      method: 'GET',
      url: `/api/initial-interview-questions/pay-transparency-data/read`,
      params: params
    });
  }

  readTalentPayTransparencyResponseData(order_id: number): Observable<any> {
    const params = new HttpParams()
      .set('orderId', order_id.toString())
    return this.apiService.httpWrapper<any>({
      method: 'POST',
      url: `/api/initial-interview-questions/pay-transparency/read-pay-transparency-response-data`,
      params: params
    });
  }
}
